import React, { useEffect } from 'react';
import { Switch, Route, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PrivateRoute from '../PrivateRoute';
import Login from 'app/pages/Login';
import Wellcome from 'app/pages/Wellcome';
import Services from 'app/pages/Services';
import PortalAccess from 'app/pages/Requests/PortalAccess';
import Registration from 'app/pages/Requests/Registration';
import Company from 'app/pages/Company/Company';
import Users from 'app/pages/Company/Users';
import { makeStyles } from '@material-ui/core';
import Header from 'app/layouts/Header';
import CrashRoute from 'app/pages/CrashRoute';
import SelectCompany from 'app/pages/SelectCompany';
import VehiclesList from 'app/pages/Lists/VehiclesList';
import InfractionsList from 'app/pages/Lists/InfractionsList';
import LicensesList from 'app/pages/Lists/LicensesList';
import LinesList from 'app/pages/Lists/LinesList';
import Survey from 'app/pages/Requests/Survey';
import Licenses from 'app/pages/Requests/Licenses';
import ChangeEmail from 'app/pages/Requests/ChangeEmail';
import Lines from 'app/pages/Requests/Lines';
import LicensesDuplicate from 'app/pages/Requests/LicensesDuplicate';
import Vehicles from 'app/pages/Requests/Vehicles';
import ResetPassword from 'app/pages/ResetPassword';
import ChangePassword from 'app/pages/ChangePassword';
import InspectionReport from 'app/pages/Requests/InspectionReport';
import { URLS } from 'app/config/urls';
import Logs from '../../../internalPages/Log';

function ExternalRoutes(props) {
  useStyles();
  const { currentTheme, setCurrentTheme } = props;
  const history = useHistory();
  const fromLogin = useSelector(state => state.settings.fromLogin);
  const currentLocation = history.location.pathname;

  useEffect(() => {
    if (currentTheme !== 'servicePortal') {
      setCurrentTheme('servicePortal');
    }
  }, [currentTheme, setCurrentTheme]);

  return (
    <>
      {currentLocation !== URLS.WRONG &&
        currentLocation !== URLS.RESET_PASSWORD &&
        (fromLogin || currentLocation !== URLS.LOGIN) && <Header />}
      <Switch>
        <Route path={URLS.LOGIN} component={Login} />
        <Route exact path={URLS.START} component={Wellcome} />
        <Route exact path={URLS.SERVICES} component={Services} />
        <Route exact path={URLS.PORTAL_ACCESS} component={PortalAccess} />
        <Route exact path={URLS.RESET_PASSWORD} component={ResetPassword} />
        <Route exact path={URLS.CHANGE_EMAIL} component={ChangeEmail} />
        <Route path={URLS.WRONG} component={CrashRoute} />
        <PrivateRoute exact path={URLS.CHANGE_PASSWORD} component={ChangePassword} />
        <PrivateRoute exact path={URLS.COMPANY_SELECT} component={SelectCompany} />
        <PrivateRoute exact path={URLS.REGISTRATION} component={Registration} />
        <PrivateRoute exact path={URLS.VEHICLES} component={Vehicles} />
        <PrivateRoute exact path={URLS.VEHICLE_CHANGE} component={Vehicles} />
        <PrivateRoute exact path={URLS.SURVEY} component={Survey} />
        <PrivateRoute exact path={URLS.INSPECTION_REPORT} component={InspectionReport} />
        <PrivateRoute exact path={URLS.COMPANY} component={Company} />
        <PrivateRoute exact path={URLS.COMPANY_USERS} component={Users} />

        <PrivateRoute exact path={URLS.LICENSES_EVENTUAL} component={Licenses} />
        <PrivateRoute exact path={URLS.LICENSES_LINKED} component={Licenses} />
        <PrivateRoute exact path={URLS.LICENSES_CHARTER} component={Licenses} />
        <PrivateRoute exact path={URLS.LICENSES_HEALTH} component={Licenses} />
        <PrivateRoute exact path={URLS.LICENSES_STUDENTS} component={Licenses} />
        <PrivateRoute exact path={URLS.LICENSES_SCHOOL} component={Licenses} />
        <PrivateRoute exact path={URLS.LICENSES_TOURISM} component={Licenses} />
        <PrivateRoute exact path={URLS.LICENSES_DUPLICATE} component={LicensesDuplicate} />

        <PrivateRoute exact path={URLS.SLIC_LINES_MODIFY_SCHEDULE} component={Lines} />
        <PrivateRoute exact path={URLS.SLIC_LINES_EXPAND_SCHEDULE} component={Lines} />
        <PrivateRoute exact path={URLS.SLIC_LINES_SUPRESS_SCHEDULE} component={Lines} />
        <PrivateRoute exact path={URLS.SLIC_LINES_CHANGE_VEHICLE} component={Lines} />
        <PrivateRoute exact path={URLS.SLIC_LINES_EXPIRATION_EXTENSION} component={Lines} />
        <PrivateRoute exact path={URLS.SLIC_LINES_TRANSFER_PERMISSION} component={Lines} />
        <PrivateRoute exact path={URLS.SLIC_LINES_CANCEL_PERMISSION} component={Lines} />
        <PrivateRoute exact path={URLS.SLIC_LINES_SUBSTITUTE_CONDUCTOR} component={Lines} />

        <PrivateRoute exact path={URLS.STRIP_LINES_LINE_EXTENSION} component={Lines} />
        <PrivateRoute exact path={URLS.STRIP_LINES_LINE_REDUCTION} component={Lines} />
        <PrivateRoute exact path={URLS.STRIP_LINES_SCHEDULE_REINFORCEMENT} component={Lines} />
        <PrivateRoute exact path={URLS.STRIP_LINES_LINE_CONNECTION} component={Lines} />
        <PrivateRoute exact path={URLS.STRIP_LINES_DEFINITIVE_ITINERARY_CHANGE} component={Lines} />
        <PrivateRoute exact path={URLS.STRIP_LINES_TEMPORARY_ITINERARY_CHANGE} component={Lines} />
        <PrivateRoute exact path={URLS.STRIP_EQUIPMENT_TYPE_INCLUSION} component={Lines} />
        <PrivateRoute exact path={URLS.STRIP_EQUIPMENT_TYPE_REPLACEMENT} component={Lines} />
        <PrivateRoute exact path={URLS.STRIP_SECTION_IMPLANTATION} component={Lines} />
        <PrivateRoute exact path={URLS.STRIP_SECTION_SUPPRESSION} component={Lines} />
        <PrivateRoute exact path={URLS.STRIP_LINES_LINE_CANCEL} component={Lines} />
        <PrivateRoute exact path={URLS.STRIP_SERVICE_CANCEL} component={Lines} />
        <PrivateRoute exact path={URLS.STRIP_SCHEDULES_MODIFICATION} component={Lines} />
        <PrivateRoute exact path={URLS.STRIP_SCHEDULES_EXTENSION} component={Lines} />
        <PrivateRoute exact path={URLS.STRIP_SCHEDULES_SUPPRESSION} component={Lines} />
        <PrivateRoute exact path={URLS.STRIP_DEADLINE_EXTENSION} component={Lines} />
        <PrivateRoute exact path={URLS.STRIP_LINES_LINE_TRANSFER} component={Lines} />

        <PrivateRoute exact path={URLS.LIST_VEHICLES} component={VehiclesList} />
        <PrivateRoute exact path={URLS.LIST_INFRACTIONS} component={InfractionsList} />
        <PrivateRoute exact path={URLS.LIST_LICENSES} component={LicensesList} />
        <PrivateRoute exact path={URLS.LIST_LINES} component={LinesList} />
        <PrivateRoute exact path={URLS.LOGS} component={Logs} />
      </Switch>
    </>
  );
}

const useStyles = makeStyles(() => ({
  '@global': {
    body: {
      background: `url(${process.env.PUBLIC_URL +
        '/img/background-root.png'}) #eee bottom right no-repeat`,
      backgroundAttachment: 'fixed',
    },
  },
}));

export default ExternalRoutes;
